import { useState } from 'react';

import { TableLayout } from 'components/ui/templates/TableLayout/TableLayout';

import { ReceiversHeader } from './ReceiversHeader';
import { ReceiversTable } from './ReceiversTable';

export const Receivers = () => {
  const [key, setKey] = useState<number>();
  return (
    <TableLayout
      header={<ReceiversHeader setKey={setKey} />}
      content={<ReceiversTable />}
      key={key}
    />
  );
};
